import { useMemo } from 'react';
import { useGetReportsQuery } from '@/api/rtk/reportsApi';

const STATUSES = ['all', 'processing', 'in-progress', 'completed', 'generated', 'urgent'];

const emptyTab = { reports: [], totalCount: 0, totalPages: 0 };

function toTab(query) {
  if (!query?.data) return emptyTab;
  return {
    reports: query.data.reports || [],
    totalCount: query.data.totalCount || 0,
    totalPages: query.data.totalPages || 0,
  };
}

export function useReportsQueries(queryArgs) {
  const skip = !queryArgs?.userId || !queryArgs?.toolId;

  const options = { skip, refetchOnMountOrArgChange: true };
  const all = useGetReportsQuery({ ...queryArgs, status: 'all' }, options);
  const processing = useGetReportsQuery({ ...queryArgs, status: 'processing' }, options);
  const inProgress = useGetReportsQuery({ ...queryArgs, status: 'in-progress' }, options);
  const completed = useGetReportsQuery({ ...queryArgs, status: 'completed' }, options);
  const generated = useGetReportsQuery({ ...queryArgs, status: 'generated' }, options);
  const urgent = useGetReportsQuery({ ...queryArgs, status: 'urgent' }, options);

  return useMemo(() => {
    const byStatus = {
      all,
      processing,
      'in-progress': inProgress,
      completed,
      generated,
      urgent,
    };

    const reports = {};
    const loading = {};
    const totalCount = {};

    STATUSES.forEach((status) => {
      reports[status] = toTab(byStatus[status]);
      // First load only — background refetches must not unmount the list/drawer.
      loading[status] = !skip && !byStatus[status]?.data && !byStatus[status]?.isError;
      totalCount[status] = byStatus[status]?.data?.totalCount ?? 0;
    });

    return { reports, loading, totalCount };
  }, [all, processing, inProgress, completed, generated, urgent, skip]);
}
